// extracted by mini-css-extract-plugin
module.exports = {"nopadding":"index-module__nopadding___vgDiL","termsSection":"index-module__termsSection___gcXPJ"};